import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';


import Swal from 'sweetalert2';
import { Router } from '@angular/router';

import { URL_SERVICIOS } from '../config/config';
import { ErrorsService } from './errors.service';
import { GeneralService } from './general.service';


@Injectable({
  providedIn: 'root'
})
export class ScheduleService {

  constructor(
    public http: HttpClient,
    public router: Router,
    public _errors: ErrorsService,
    public _generalServices: GeneralService
  ) { }



  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       getScheduleTimes       /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getScheduleTimes(fechaSeleccionada = null) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {
      'fechaSeleccionada': fechaSeleccionada
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/getScheduleTimes', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
    }
  }
 
  
  async postListarAgendaMedicoDia(doc_id, fecha){
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {
      doc_id: doc_id,
      fecha: fecha
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/postListarAgendaMedicoDia', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
    }
    
  }


  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       getScheduleHours        /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Consulta todas las horas disponibles del doctor
  async getScheduleHours(id_doctor, available, sch_sta_id, sch_hou_sta_id, date_day, next) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {
      doc_id: id_doctor,                                    // null= todos
      available: available,                                 // false indica dias disponibles, dominante
      sch_sta_id: sch_sta_id,                               // null=todos 7,8
      sch_hou_sta_id: sch_hou_sta_id,       // 11 / null = todos
      date_day: date_day,                                   // '20201006' (usa >=) //null=todos
      next: next,                                           // solo la proxima hora
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/getScheduleHours', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw 1;
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       getScheduleHoursDoc        /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Consulta todas las horas del mes de un doctor
  async getScheduleHoursDoc(id_doctor, mes, todas, agenda = false) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {
      doc_id: id_doctor,                         // 
      mes: mes,
      todas: todas,
      agenda: agenda                          //='yyyymm'. si es null entrega el mes
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/getScheduleHoursDoc', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       getScheduleHoursDisp      /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getScheduleHoursDisp(id_doctor, mes = null, todas = null) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {
      doc_id: id_doctor,
      mes: mes,
      todas: todas,
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/getScheduleHoursDisp', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
    }
  }



  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       addScheduleHours        /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async addScheduleHours(id_doctor, day, hours, is_ondemand) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {
      doc_id: id_doctor,
      day: day,
      hours: hours,
      is_ondemand: is_ondemand // ✅ SE AGREGA AQUÍ
    };
    try {
      let data = await this.http.post(URL_SERVICIOS + '/addScheduleHours', JSON.stringify(params), httpOptions).toPromise();
      return data;
    }
    catch (error) {
      this._errors.requestError(error);
    }
  }
  
  async editScheduleHours(id_doctor, hours, edit_reason = '', is_ondemand, day = null) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {
      doc_id: id_doctor,
      hours: hours,
      edit_reason: edit_reason,
      is_ondemand: is_ondemand, // ✅ SE AGREGA AQUÍ
      day: day
    };
    try {
      let data = await this.http.post(URL_SERVICIOS + '/editScheduleHours', JSON.stringify(params), httpOptions).toPromise();
      return data;
    }
    catch (error) {
      this._errors.requestError(error);
    }
  }
  

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       getAppointment       /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Consulta todas las horas disponibles del doctor
  async getAppointment(id_usuario, id_doctor, boo_id = null, sch_hou_id = null, next = false) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {
      use_id: id_usuario,              // not null
      doc_id: id_doctor,               //
      boo_id: boo_id,
      sch_hou_id: sch_hou_id,
      next: next,                       // proximas consultas
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/getAppointment', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
    }
  }


  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       scheduleAppointment        /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async scheduleAppointment(sch_hou_id, ben_id, sub_spe_id, data_selected, use_id, code, payment_type = null) {
    const httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
    let dispositivo = this._generalServices.getDevice();
    //console.log(dispositivo);

    let params = {
      sch_hou_id: sch_hou_id,
      ben_id: ben_id,
      sub_spe_id: sub_spe_id,
      data_selected: data_selected,
      device_type: dispositivo.type,
      use_id: use_id,
      code,
      payment_type
    }
    // console.log(params);

    try {
      let data = await this.http.post(URL_SERVICIOS + '/scheduleAppointment', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      // this._errors.requestError(error);
      throw error;
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       payAppointment        /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async payAppointment(id_consulta) {
    const httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
    // let dispositivo = this._generalServices.getDevice();

    let params = {
      id_consulta: id_consulta,
    }

    try {
      let data = await this.http.post(URL_SERVICIOS + '/payAppointment', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      // this._errors.requestError(error);
      throw error;
    }
  }
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       cancelAppointment       /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async cancelAppointment(boo_id, use_id, cancel_reason, data_selected = null, cancel_by, doc_id = null) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let dispositivo = this._generalServices.getDevice();
    //console.log(dispositivo);

    let params = {
      boo_id: boo_id,
      use_id: use_id,
      cancel_reason: cancel_reason,
      cancel_by: cancel_by,
      data_selected: data_selected,
      device_type: dispositivo.type,
      doc_id: doc_id,
    }

    //console.log(params);

    try {
      let data = await this.http.post(URL_SERVICIOS + '/cancelAppointment', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw (error);
    }
  }
  async postCancelWaitList(paciente, id_ondemand, reason) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let dispositivo = this._generalServices.getDevice();
    //console.log(dispositivo);

    let params = {
      paciente: paciente,
      id_ondemand: id_ondemand,
      reason: reason            
    };
    // console.log(params);

    try {
      let data = await this.http.post(URL_SERVICIOS + '/postCancelWaitList',params, httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw (error);
    }
  }

  async getListarCancelReason(cancelFrom) {
    let httpOptions = {
      headers: new HttpHeaders({
        // 'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {
      cancelFrom: cancelFrom
        }
  
    try {
      let data = await this.http.post(URL_SERVICIOS + '/getListarCancelReason', params, httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw (error);
    }
  }

  async postActualizarNoMostrarModalVL(){
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    try {
      let data = await this.http.post(URL_SERVICIOS + '/postNoMostrarModalVL', {}, httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw (error);
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       editAppointment       /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async editAppointment(data, data_selected) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {
      sch_hou_id: data.sch_hou_id,
      ben_id: data.ben_id,
      sub_spe_id: data.sub_spe_id,
      boo_id: data.boo_id,
      use_typ_name: data.use_typ_name,
      data_selected: data_selected,
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/editAppointment', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      // this._errors.requestError(error)
      throw (error);

    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       getDoctor         /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Consulto listado de doctores
  async getDoctor(doctor_name_selected, doctor_surname_selected, speciality_id) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
    let params = {
      nombre: doctor_name_selected.toUpperCase(),
      apellidoPaterno: doctor_surname_selected.toUpperCase(),
      idEspecialidad: speciality_id,
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/postListarDoctor', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       editDoctor         /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async editDoctor(data) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
    let params = {
      idDoctor: data.idDoctor,
      docNumeroRegistro: data.docNumeroRegistro,
      docFechaRegistro: data.docFechaRegistro,
      idUsuario: data.idUsuario,
      idtitulo: data.idtitulo,
      fechaEmisionTitulo: data.fechaEmisionTitulo,
      idInstitucion: data.idInstitucion,
      idEspecialidad: data.idEspecialidad,
      comentarios: data.comentarios
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/postModificarDoctor', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
    }
  }


  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
  ////////////////////////////////////////////////////////////////////       postInsertSurvey         /////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async postInsertSurvey(params) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/postInsertSurvey', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      throw error;
      // this._errors.requestError(error)
    }
  }


  async getListarConsultasPendientes(id_consulta) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {
      id_consulta: id_consulta
    }
    try {
      let data = await this.http.post(URL_SERVICIOS + '/getListarConsultasPendientes', params, httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
    }
  }


  async typificationsAppointment() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {};

    try {
      let data = await this.http.post(URL_SERVICIOS + '/typificationsAppointment', params, httpOptions).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
    }
  }

  async updateStateAppointment(id_consulta, typ_id, reason,) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let dispositivo = this._generalServices.getDevice();

    let params = {
      id_consulta: id_consulta,
      typ_id: typ_id,
      reason: reason,
      device: dispositivo.type,
    };

    // console.log(params);
    try {
      let data = await this.http.post(URL_SERVICIOS + '/updateStateAppointment', params, httpOptions).toPromise()
      return data
    }
    catch (error) {
      // this._errors.requestError(error)
      throw error;
    }
  }



  // OnDemand


  async postListUsersWaitList(use_id, typ_id) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    let params = {
      user_id: use_id,
      typ_id: typ_id
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/postListUsersWaitList', params, httpOptions).toPromise()
      return data
    }
    catch (error) {
      // this._errors.requestError(error)
    }
  }

  async getPacienteWaitListOnDemand({ id_doc }) {
    // console.log("ID_DOC recibido en el servicio:", id_doc); // 👈 Verificar si llega undefined
  
    let httpOptions = {
      headers: new HttpHeaders({
        
        'Content-Type': 'application/json'
      })
    };
    let params = { id_doc: id_doc };
  
    try {
      let data = await this.http.post(URL_SERVICIOS + '/getPacienteWaitListOnDemand', params, httpOptions).toPromise();
      return data;
    }
    catch (error) {
      this._errors.requestError(error);
    }
  }

  async postAceptarConsultaOnDemand({ id_doc, aceptado, tel_doc_od_id }) {
    // console.log("Datos recibidos en el servicio:", { id_doc, aceptado, tel_doc_od_id });
  
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    
    let params = {
      id_doc: id_doc,
      aceptado: aceptado,  // true o false
      tel_doc_od_id: tel_doc_od_id,
    };
  
    try {
      let data = await this.http.post(URL_SERVICIOS + '/postAceptarConsultaOnDemand', params, httpOptions).toPromise();
      return data;
    }
    catch (error) {
      this._errors.requestError(error);
    }
  }
  
  async postIngresarAtencionOnDemand({ use_id, aceptado, tel_doc_od_id, id_doctor }) {
    // console.log("Datos recibidos en el servicio:", { use_id, aceptado, tel_doc_od_id });
  
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    
    let params = {
      use_id: use_id,
      aceptado: aceptado,  // true o false
      tel_doc_od_id: tel_doc_od_id,
      id_doctor: id_doctor
    };
  
    try {
      let data = await this.http.post(URL_SERVICIOS + '/postIngresarAtencionOnDemand', params, httpOptions).toPromise();
      return data;
    }
    catch (error) {
      this._errors.requestError(error);
    }
  }
  
  


  async postAddWaitList(params) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/postAddWaitList', JSON.stringify(params), httpOptions).toPromise()
      return data
    }
    catch (error) {
      throw error;
      // this._errors.requestError(error)
    }
  }
  async getDetailOndemand() {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/getDetailOndemand', '', httpOptions).toPromise()
      return data
    }
    catch (error) {
      throw error;
      // this._errors.requestError(error)
    }
  }
  async postOnDemandDoctor(params: { doc_id: number, estado: boolean, conf_by: number, conf_typ: number, agenda_id: number }) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
  
    try {
      let data = await this.http.post(URL_SERVICIOS + '/postOnDemandDoctor', JSON.stringify(params), httpOptions).toPromise();
      return data;
    }
    catch (error) {
      throw error;
    }
  }
  async postPausarDoctorOD(params: { doc_id: number, paused: boolean, motivo_pausa: string}) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
  
    try {
      let data = await this.http.post(URL_SERVICIOS + '/postPausarDoctorOD', JSON.stringify(params), httpOptions).toPromise();
      return data;
    }
    catch (error) {
      throw error;
    }
  }
  async getVerificarPausaDocOndemand(params: { doc_id: number}) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
  
    try {
      let data = await this.http.post(URL_SERVICIOS + '/getVerificarPausaDocOndemand', JSON.stringify(params), httpOptions).toPromise();
      return data;
    }
    catch (error) {
      throw error;
    }
  }
  async postHablitarHorasOndemand(params: { doc_id: number, estado: boolean, conf_by: number, conf_typ: number, agenda_id: number }) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };
  
    try {
      let data = await this.http.post(URL_SERVICIOS + '/postHablitarHorasOndemand', JSON.stringify(params), httpOptions).toPromise();
      return data;
    }
    catch (error) {
      throw error;
    }
  }
  
  async postPayPendingAppointments(params:{id_consulta: number, typePayment: string, use_id: number, ben_id: number}) {
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }),
    };

    try {
      let data = await this.http.post(URL_SERVICIOS + '/postPayPendingAppointments', JSON.stringify(params), httpOptions).toPromise();
      return data;
    }
    catch (error) {
      throw error;
    }
  }

async asignarMedicoPaciente(){
    let httpOptions = {};
 
    try {
      let data = await this.http.post(URL_SERVICIOS + '/postAsignarMedicoPaciente', '', httpOptions).toPromise()
      return data
    }
    catch (error) {
      throw error;
      // this._errors.requestError(error)
    }
  }
}
